import { createPortal } from 'react-dom';

interface MantenimientoHistorial {
  id: string;
  tipo?: string;
  categoria?: string;
  descripcion?: string;
  fecha_programada?: string;
  fecha_atencion?: string;
  costo_total?: number;
}

interface HistorialMantenimientosTicketProps {
  bus: { padron?: string; numero?: string; placa: string };
  mantenimientos: MantenimientoHistorial[];
  desde: string;
  hasta: string;
}

const HistorialMantenimientosTicket = ({ bus, mantenimientos, desde, hasta }: HistorialMantenimientosTicketProps) => {
  return createPortal(
    <div className="ticket-print-only">
      <p className="centro bold titulo">SISTEMA MANTSILA</p>
      <p className="centro">Historial de Mantenimientos</p>
      <hr />
      <p><span className="bold">Bus:</span> Padrón {bus.padron || bus.numero} - {bus.placa}</p>
      <p><span className="bold">Periodo:</span> {desde} a {hasta}</p>
      <p><span className="bold">Total:</span> {mantenimientos.length} mantenimiento(s)</p>
      <hr />
      {mantenimientos.length === 0 && (
        <p className="centro">Sin mantenimientos en este periodo</p>
      )}
      {mantenimientos.map((m, i) => (
        <div key={m.id}>
          <p className="bold">{i + 1}. {m.tipo} {m.categoria ? `- ${m.categoria.replace(/_/g, ' ')}` : ''}</p>
          {m.fecha_programada && <p>Programado: {new Date(m.fecha_programada).toLocaleDateString('es-PE')}</p>}
          {m.fecha_atencion && <p>Atendido: {new Date(m.fecha_atencion).toLocaleDateString('es-PE')}</p>}
          {m.descripcion && <p>{m.descripcion.slice(0, 90)}</p>}
          {!!m.costo_total && Number(m.costo_total) > 0 && <p>Costo: S/ {Number(m.costo_total).toFixed(2)}</p>}
          <hr />
        </div>
      ))}
      <p className="centro" style={{ marginTop: '4mm' }}>Fin del historial</p>
    </div>,
    document.body
  );
};

export default HistorialMantenimientosTicket;
